import { FC, PropsWithChildren, useMemo } from 'react';
import { SearchTooltipContext } from './context';
import { useDispatch, useSelector } from 'react-redux';
import { selectFiltersMeta } from '../../../../selectors/filters';
import { EFiltersMetaStatus } from '../../../../types/filters';
import { applyFilters } from '../../../../actions/filters';
import * as React from 'react';

export const SearchTooltipProvider: FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch();

  const { data, status } = useSelector(selectFiltersMeta);

  const context = useMemo(
    () => ({
      offersCount: data?.count || 0,
      loading: status === EFiltersMetaStatus.Pending,
      onApply: () => {
        dispatch(applyFilters());
      },
    }),
    [data?.count, dispatch, status],
  );

  return <SearchTooltipContext.Provider value={context}>{children}</SearchTooltipContext.Provider>;
};
